import { Injectable } from '@angular/core';
import { SubscriptionPlans } from './user/user.model';
import { MenuGroupType } from '../map/map.component';
import { IntegrationsService } from '../shared/util/integrations';

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor(private integrations: IntegrationsService) {}

  public logSubscriptionGetStarted(
    plan: SubscriptionPlans,
    monthly: boolean,
    promoCode: string | null
  ) {
    this.integrations.track(
      'SUBSCRIPTION_GET_STARTED',
      {
        subscription_plan: plan,
        subscription_period: monthly ? 'MONTHLY' : 'YEARLY',
        subscription_promo_code: promoCode,
      },
      { ga: true, amplitude: true }
    ); // Track in amplitude too
  }

  public logSubscriptionToPayment(
    plan: SubscriptionPlans,
    monthly: boolean,
    promoCode: string | null
  ) {
    this.integrations.track(
      'SUBSCRIPTION_TO_PAYMENT',
      {
        subscription_plan: plan,
        subscription_period: monthly ? 'MONTHLY' : 'YEARLY',
        subscription_promo_code: promoCode,
      },
      { ga: true, amplitude: true }
    );
  }

  public logSeeAllIndicators(plan: SubscriptionPlans) {
    this.integrations.track(
      'PROFILE_SUBSCRIPTION_ALL_INDICATORS',
      {
        subscription_plan: plan,
      },
      { ga: true, amplitude: true }
    );
  }

  public logSampleReportClicked(plan: SubscriptionPlans) {
    this.integrations.track(
      'PROFILE_SUBSCRIPTION_SAMPLE_REPORT',
      {
        subscription_plan: plan,
      },
      { ga: true, amplitude: true }
    );
  }

  public logToggleSubscriptionPeriod(monthly: boolean) {
    this.integrations.track(
      'PROFILE_SUBSCRIPTION_PERIOD_TOGGLE',
      {
        subscription_period: monthly ? 'MONTHLY' : 'YEARLY',
      },
      { ga: true, amplitude: true }
    );
  }

  public logClicksReachedLimit() {
    this.integrations.track('FREE_CLICKS_LIMIT_REACHED', {
      ga: true,
      amplitude: true,
    });
  }

  public logReportOrderTypeConfirmed() {
    this.integrations.track('ORDER_REPORT_CONFIRM_TYPE', {
      ga: true,
      amplitude: true,
    });
  }

  public logReportOrderLocationConfirmed() {
    this.integrations.track('ORDER_REPORT_CONFIRM_LOCATION', {
      ga: true,
      amplitude: true,
    });
  }

  public logReportToPayment(priceCents: number) {
    this.integrations.track(
      'ORDER_REPORT_TO_PAYMENT',
      {
        value: priceCents / 100, // Standard GA4 parameter
        currency: 'USD',
      },
      { ga: true, amplitude: true }
    );
  }

  public logFreeReportOrder() {
    this.integrations.track(
      'FREE_REPORT_ORDER',
      {},
      { ga: true, amplitude: true }
    );
  }

  public logCompareLocationsClick(from: 'map' | 'compare-page') {
    this.integrations.track(
      'COMPARE_CLICK',
      { compare_source: from },
      { ga: true, amplitude: true }
    );
  }

  public logMenuGroupChanged(group: MenuGroupType) {
    this.integrations.track(
      'MENU_GROUP_CHANGED',
      { menu_group: group },
      { ga: true, amplitude: true }
    );
  }
}
